import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Asset, AssetColumns } from "~/modules/assets/types";
import { formatBpsValue } from "~/utils/formatBpsValue";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const TOTAL_PERFORMANCE_FEE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.totalPerformanceFeeBps,
    sortsOn: AssetColumns.totalPerformanceFeeBps,
    label: (
        <>
            Performance
            <br />
            Fees
        </>
    ),
    tooltip: CatalogReferenceDataSlugs.total_performance_fee_bps,
    type: ColumnTypes.percent,
    width: 160,
    loginRequired: true,
    cellValue: (item) => {
        if (item.isAsset) {
            const asset = item as Asset;
            const { total_performance_fee_bps } = asset;
            return formatBpsValue(total_performance_fee_bps);
        }

        return null;
    },
};
